import { render, staticRenderFns } from "./addedit-user.vue?vue&type=template&id=8d0d3c54&scoped=true"
import script from "./addedit-user.vue?vue&type=script&lang=js"
export * from "./addedit-user.vue?vue&type=script&lang=js"
import style0 from "./addedit-user.vue?vue&type=style&index=0&id=8d0d3c54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0d3c54",
  null
  
)

export default component.exports